import { makeStyles } from '@mui/styles';
import { LYNKED_DEEP_GREEN, LYNKED_DEEP_GREEN_HOVER } from '../../consts/colors';

const useStyles = makeStyles(() => ({
  BoxTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  Settings: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100%',
    padding: '24px 24px 0 24px',
  },
  Content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'center',
  },
  OperatingHourSettings: {
    borderRadius: '4px',
    color: 'rgba(0, 0, 0, 0.87)',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    display: 'flex',
    gap: '8px',
    flexDirection: 'column',
  },
  OperatingHourSettingsTitle: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
  },
  OperatingHourSettingsContent: {
    padding: '16px',
  },
  BoxCard: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '12px',
    flexShrink: 0,
    borderRadius: '12px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
  },
  BoxButtonLoader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  SkeletonButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '30%',
  },
  SkeletonBoxContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const buttonStyle = {
  width: 'auto',
  backgroundColor: LYNKED_DEEP_GREEN,
  height: '47px',
  borderRadius: '4px',
  opacity: '1',
  color: 'white',
  margin: '20px 0px',
  '&:hover': { backgroundColor: LYNKED_DEEP_GREEN_HOVER },
};

export { useStyles, buttonStyle };
